import {useLang} from "../context/LanguageContext";
import {Link} from "react-router-dom";

const Footer = () => {
    const { t } = useLang();

    return (
        <>
        <div className="max-w-[95vw] md:max-w-[800px] mx-auto my-2 bg-[#34495e] border-2 border-[#2ecc71] rounded-[10px] flex items-center justify-between p-2">
            <img src="/assets/images/18+.png" alt="18+" style={{width: "40px", height: "40px", marginRight:"16px"}} />
            <p className="text-sm font-extrabold text-[#e67e22]">{t('txt.18+')}</p>
        </div>
        <Link to="/terms" className="max-w-[95vw] md:max-w-[800px] mx-auto my-2 bg-[#34495e] border-2 border-[#2ecc71] rounded-[10px] flex items-center p-2 text-[#e67e22] justify-center uppercase font-bold">
            {t('auth.terms2')}
        </Link>
        </>
    )
}

export default Footer;